import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'home',
  created () {
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.getReporSendFails()
  },
  computed: {
    canManage () {
      return this.$store.getters.canManage
    },
    notify() {
      return this.$store.getters.planNotify
    },
    reportSendFails () {
      return this.$store.getters.reportHistoriesErrorCount
    }
  },
  methods: {
    getReporSendFails () {
      this.$store.dispatch('REPORT_HISTORY_GET_SEND_FAILS_SUM', {data: {'shop_id': this.shopId}, clear: true})
    },
    /** 別ドメイン 社員・組織に遷移 */
    goSyainsoshiki () {
      var url = config.syainsoshiki.method + '://' + config.syainsoshiki.server + config.syainsoshiki.auth
      var redirect = config.syainsoshiki.redirect
      // url
      var query = []
      query.push('access_token=' + encodeURIComponent(window.localStorage.getItem('access_token')))
      query.push('keep_limit='   + encodeURIComponent(window.localStorage.getItem('keep_limit')))
      query.push('shop_id='      + encodeURIComponent(window.localStorage.getItem('shop_id')))
      query.push('user_type='    + encodeURIComponent(window.localStorage.getItem('user_type')))
      query.push('redirect='     + encodeURIComponent(redirect))
      url += '?' + query.join('&')
      window.open(url, 'syainsoshiki')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/home.js